module.exports = __webpack_public_path__ + "img/red_064.0d08e837.png";